import { useState } from 'react';

import { Outlet } from 'react-router-dom';

import { DataProvider } from '@/contexts/data';
import { Header } from '@/layout/app/Header';
import { Sidebar } from '@/layout/app/Sidebar';

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <DataProvider>
      <div className="flex min-h-[100vh] min-w-0 bg-white">
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="flex min-w-0 max-w-full flex-1 flex-col md:ml-64">
          <Header setSidebarOpen={setSidebarOpen} />
          <main className="flex min-w-0 w-full flex-1 flex-col pt-16">
            <Outlet />
          </main>
        </div>
      </div>
    </DataProvider>
  );
}
